import { useState } from 'react'
import { Box, ClickAwayListener, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

function HintIcon({ hint }: { hint: string }) {
  const [open, setOpen] = useState(false)

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={hint}
        arrow
        open={open}
        onClose={() => setOpen(false)}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <IconButton
          type="button"
          size="small"
          disableRipple
          sx={{ p: 0.25 }}
          onClick={(e) => {
            e.stopPropagation()
            setOpen((o) => !o)
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  )
}

export default function ComputedField({
  label,
  value,
  hint,
  tone = 'default',
}: {
  label: string
  value: string
  hint?: string
  tone?: 'default' | 'negative'
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
          {label}
        </Typography>
        {hint && <HintIcon hint={hint} />}
      </Stack>
      <Typography variant="body1" sx={{ color: tone === 'negative' ? 'error.main' : undefined }}>
        {value || '—'}
      </Typography>
    </Box>
  )
}
